import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4229e38e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-sidebar" }

import ChatSidebarTopBar from "./ChatSidebarTopBar.vue";
import ChatsPreviewContainer from "./ChatsPreviewContainer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSidebar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChatSidebarTopBar),
    _createVNode(ChatsPreviewContainer)
  ]))
}
}

})